module.exports = __webpack_public_path__ + "img/二星高级大师@3x.461afb0c.png";